import classNames from 'classnames';
import Link from 'next/link';
import Image from 'next/image';
import { useSanitizedTranslation } from 'ui';

export const ButtonRow = ({ buttons }) => {
  return (
    <div className="align-start flex justify-start space-x-8">
      {buttons.map(button => (
        <XumoButton {...button} />
      ))}
    </div>
  );
};

export const XumoButton = ({ submit, children, light, href, onClick, label, target, disabled, alignment, secondary, primary, color, padding, className }) => {
  const style = light
    ? `${primary ? 'border-white bg-white text-black' : secondary ? 'bg-transparent text-white border-white' : 'bg-white text-black'}`
    : `${primary ? 'border-black bg-black text-white' : secondary ? 'bg-transparent text-black border-black' : 'bg-black text-white'}`;
  const addAlignment = alignment ? alignment : 'self-center';
  const { t } = useSanitizedTranslation();

  const classes = classNames(
    'btn',
    'cursor-pointer',
    'rounded-md',
    'border-2',
    'border-black',
    'text-[16px]',
    'weight-600',
    style,
    addAlignment,
    'outline',
    'outline-2',
    'outline-offset-2',
    'outline-transparent',
    color ? `hover:outline-${color}` : 'hover:outline-xumoTeal',
    'transition-colors',
    padding ? padding : 'px-8 py-4',
    'inline-block',
    'whitespace-nowrap',
    'disabled:bg-xumoOnyx disabled:text-xumoCharcoal',
    className,
  );

  return submit ? (
    <button data-i18n={label || children} onClick={onClick} className={classes} disabled={disabled}>
      {t(label) || t(children)}
    </button>
  ) : (
    <Link data-i18n={label || children} onClick={onClick} href={href || ''} className={classes} target={target} disabled={disabled}>
      {t(label) || t(children)}
    </Link>
  );
};

export const ImageButton = ({ children, image, hoverImage, href, onClick, label, target, disabled }) => {
  const classes = classNames('btn', 'cursor-pointer', 'inline-block', 'whitespace-nowrap');

  return (
    <Link onClick={onClick} href={href || ''} className={classes} aria-label={label}>
      <Image {...image} />
    </Link>
  );
};

export const DownloadButton = ({ children, image, hoverImage, href, onClick, label, target, disabled, store }) => {
  const classes = classNames('btn', 'cursor-pointer', 'inline-block', 'whitespace-nowrap');

  return (
    <Link
      onClick={onClick}
      href={href || ''}
      className={classNames(
        classes,
        'flex',
        'items-center',
        'rounded-md',
        'border-2',
        'border-white',
        'bg-white',
        'px-2',
        'py-1',
        'sm:px-4',
        'sm:py-3',
        'outline', // Missing this!
        'outline-2',
        'outline-offset-2',
        'outline-transparent',
        'transition-colors',
        'hover:outline-xumoTeal',
        'h-[50px]',
        'w-auto',
        'sm:w-[170px]',
        'sm:h-[63px]',
      )}
      target={target || '_blank'}
    >
      <Image
        src={
          store === 'apple'
            ? '/static/images/download-button-logos/jan-2026-app-store.png'
            : store === 'google'
            ? '/static/images/download-button-logos/jan-2026-google-play.png'
            : ''
        }
        alt={'Get it on Google Play'}
        width={130}
        height={35}
      />
    </Link>
  );
};
